// extracted by mini-css-extract-plugin
module.exports = {"rotation":"PageNotFoundTemplate_rotation__Eb70I"};